import React from 'react';
import styles from './IconArrowDown.module.scss'
export const COLOUR = {
	PINK: '#CA5263',
	DARK_PINK: '#8F4E6D',
	NAVY: '#072241',
	GREY: '#B0B6BA',
	DARK_RED: '#b4284c',
};
const IconArrowDown = ({ color }) => {
	return (
		<svg className={styles.size} width="16" height="11" viewBox="0 0 16 11" fill="none">
			<path
				d="M15.6364 1.36365L8.50428 9.36365L1.63635 1.65994"
				stroke={color}
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default IconArrowDown;

IconArrowDown.defaultProps={
	color:'#000000'
}